import { Component } from '@angular/core';

@Component({
  selector: 'app-support-page-skeleton-loader',
  templateUrl: './support-page-skeleton-loader.component.html',
  standalone: false,
})
export class SupportPageSkeletonLoaderComponent {}
